export const jackpotsComponentsController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        RELOAD_JACKPOT_COMPONENT: {
          target: 'updatingJackpots',
        },
      },
    },
    updatingJackpots: {
      invoke: {
        src: 'getJackpotsComponentsContent',
        onDone: {
          actions: {
            type: 'batchLayoutOperations',
            data: '$event.data.updates',
            meta: {
              selectors: ['$action.data'],
            },
          },
          target: 'controllerIdle',
        },
      },
    },
  },
};
